import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { AGENTS_QUERY } from 'apollo'
import { merge } from 'merge-anything'

const DEFAULTS = {
  variables: {
    query: {},
  },
}

export const useAgentsQuery = (options: QueryHookOptions<any, any> = {}) =>
  useQuery(AGENTS_QUERY, merge(options, DEFAULTS))
